import '.cc{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.gv{min-height:200px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.d5{align-items:flex-start;}.ssr-plugin'
import '.a3{padding:2rem;}.ssr-plugin'
import '.d9{background:var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.j1{top:50%;}.ssr-plugin'
import '.j2{right:1rem;}.ssr-plugin'
import '.j3{transform:translateY(-50%);}.ssr-plugin'
import '.j4{width:120px;}.ssr-plugin'
import '.j5{height:120px;}.ssr-plugin'
import '.j6{z-index:0;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.ih{z-index:1;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.j7{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="cc h gv l m a1 d5 a3 d9 c"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="az j1 j2 j3 j4 j5 j6 l aa a1"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="cc ih l m d5 n j7"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
